<template>
    <div class="position-relative border rounded overflow-hidden bg-light">
        <div style="height: 180px;">
            <img
                v-if="previewType === 'image' && previewUrl"
                :src="previewUrl"
                :alt="`${imageFile.name} preview`"
                class="d-block w-100 h-100"
                style="object-fit: cover;"
            >

            <object
                v-else-if="previewType === 'pdf' && previewUrl"
                :data="previewUrl"
                type="application/pdf"
                class="d-block w-100 h-100"
            >
                <!-- 表示できない場合のフォールバック要素 -->
                <div class="d-flex flex-column align-items-center justify-content-center text-muted h-100 px-2">
                    <i class="fa-solid fa-file-pdf fs-4 mb-2 text-danger"></i>
                    <span class="small text-center">このブラウザではPDFプレビューに対応していません</span>
                    <a
                        :href="previewUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="btn btn-sm btn-outline-secondary mt-2"
                    >
                        別タブで開く
                    </a>
                </div>
            </object>

            <div
                v-else
                class="d-flex align-items-center justify-content-center text-muted h-100"
            >
                <i class="fa-regular fa-image me-2"></i>
                <span>プレビュー不可</span>
            </div>
        </div>

        <button
            type="button"
            class="btn btn-sm btn-danger position-absolute top-0 end-0 m-2 d-flex align-items-center"
            @click="handleRemoveClick"
            aria-label="ファイルを削除"
        >
            <i class="fa-regular fa-trash-can me-1"></i>
            <span>削除</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ImageFilePreview',
    props: {
        imageFile: {
            type: File,
            required: true
        }
    },
    emits: ['remove'],
    data() {
        return {
            previewUrl: '',
            previewType: 'none'
        };
    },
    watch: {
        imageFile: {
            immediate: true,
            handler(next_file) {
                this.updatePreview(next_file);
            }
        }
    },
    beforeUnmount() {
        this.resetPreview();
    },
    methods: {
        /**
         * プレビュー可能なファイル種別を判定する。
         * MIME が空のケースを考慮し、拡張子によるPDF判定も行う。
         * @param {File} next_file
         * @returns {'image'|'pdf'|'none'}
         */
        resolvePreviewType(next_file) {
            if (!(next_file instanceof File)) {
                return 'none';
            }

            const mime_type = `${next_file.type || ''}`.toLowerCase();
            const file_name = `${next_file.name || ''}`.toLowerCase();
            const is_image = mime_type.startsWith('image/');
            const is_pdf = mime_type === 'application/pdf' || /\.pdf$/i.test(file_name);

            if (is_image) {
                return 'image';
            }

            if (is_pdf) {
                return 'pdf';
            }

            return 'none';
        },

        /**
         * Object URL を破棄し、プレビュー状態を初期化する。
         * @returns {void}
         */
        resetPreview() {
            this.revokePreviewUrl(this.previewUrl);
            this.previewUrl = '';
            this.previewType = 'none';
        },

        /**
         * ファイル変更時にプレビュー状態を更新する。
         * @param {File} next_file
         * @returns {void}
         */
        updatePreview(next_file) {
            this.resetPreview();

            const preview_type = this.resolvePreviewType(next_file);
            if (preview_type === 'none') {
                return;
            }

            this.previewUrl = URL.createObjectURL(next_file);
            this.previewType = preview_type;
        },

        /**
         * Object URL を解放する。
         * @param {string} target_url
         * @returns {void}
         */
        revokePreviewUrl(target_url) {
            if (target_url) {
                URL.revokeObjectURL(target_url);
            }
        },

        handleRemoveClick() {
            this.$emit('remove', this.imageFile);
        }
    }
};
</script>
